import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import SpecDescription from './SpecDescription';
import { trackEvent, toggleSpecCategoryEvent } from '../utils/analytics';

import '../global-sass/main.scss';

const SpecCategory = (props) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpand = () => {
		const { specCategory, widgetInfo } = props;
		const { windowId, widgetName } = widgetInfo;
		setIsExpanded((previousState) => !previousState);
		trackEvent(
			toggleSpecCategoryEvent(
				widgetName,
				windowId,
				isExpanded,
				specCategory
			)
		);
	};

	const {
		specCategory,
		specIds,
		specification,
		prefs,
		prefs: {
			widgetHeading,
			toggleCollapse,
			panelHeadingWeight,
			panelHeadingCase
		},
		isFullWidthLayout
	} = props;
	const icon = isExpanded ? 'collapse' : 'expand';
	const panelHeader = (
		<h4>
			<div className={`${panelHeadingWeight} ${panelHeadingCase}`}>
				<i
					className={`ddc-icon icon-style-collapse ddc-icon-${icon} mr-3`}
				/>
				{specCategory}
			</div>
		</h4>
	);

	let panelGroupClass = 'spec-category m-0 mb-5 mb-sm-6';

	if (widgetHeading && toggleCollapse === 'true') {
		panelGroupClass = `${panelGroupClass} mx-5`;
	}

	return (
		<PanelGroup
			data-spec-category={specCategory.toLowerCase()}
			id={`detailed-spec-category-${specCategory.toLowerCase()}`}
			className={panelGroupClass.trim()}
		>
			<Panel className="border-0" onToggle={toggleExpand}>
				<Panel.Heading>
					<Panel.Title toggle>{panelHeader}</Panel.Title>
				</Panel.Heading>
				<Panel.Collapse>
					<Panel.Body>
						<SpecDescription
							prefs={prefs}
							specIds={specIds}
							specification={specification}
							isFullWidthLayout={isFullWidthLayout}
						/>
					</Panel.Body>
				</Panel.Collapse>
			</Panel>
		</PanelGroup>
	);
};

SpecCategory.propTypes = {
	prefs: PropTypes.shape({
		widgetHeading: PropTypes.string,
		toggleCollapse: PropTypes.string,
		panelHeadingWeight: PropTypes.string,
		panelHeadingCase: PropTypes.string
	}),
	specCategory: PropTypes.string.isRequired,
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.shape({}).isRequired
		})
	).isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired,
	isFullWidthLayout: PropTypes.bool
};

SpecCategory.defaultProps = {
	prefs: {
		panelHeadingCase: 'text-capitalize',
		panelHeadingWeight: 'font-weight-bold',
		toggleCollapse: '',
		widgetHeading: ''
	}
};

export default SpecCategory;
